import { AxiosResponse } from "axios";
import { postRequest } from "../commonActions/post";
import { Requests } from "../../config/api";
import { ProtocolService } from "../../declarations/protocolService";

export const CreateProtocolService = async ( payload:ProtocolService) => {
    try {
      const response: AxiosResponse<any> = await postRequest({
        route: Requests.post.protocolService,
        payload, 
    
      });
      const protocolServiceResponse = response?.data.protocolService
      const status = response?.status;
      const message = response?.data?.message;
      const errors = response?.data?.errors;
  
      return {
        protocolServiceResponse,
        status,
        message,
        errors,
      };
    } catch (error) {
      console.error("Error in CreateInsuranceProvider:", error);
      throw error;
    }
  };
  